import { render, staticRenderFns } from "./editMessage.vue?vue&type=template&id=63c4a72a&scoped=true&"
import script from "./editMessage.vue?vue&type=script&lang=js&"
export * from "./editMessage.vue?vue&type=script&lang=js&"
import style0 from "./editMessage.vue?vue&type=style&index=0&id=63c4a72a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c4a72a",
  null
  
)

export default component.exports